import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PropertyCard.css';

const PropertyCard = ({ property, badge }) => {
    const navigate = useNavigate();

    // Helper to handle data differences between Search/Home
    const imageSync = property.image || (property.images && property.images[0]);
    const bhkSync = property.bhk || property.bedrooms;
    const sqftSync = property.sqft || property.area_sqft;

    return (
        <div
            className="clean-property-card"
            onClick={() => navigate(`/properties/${property.id}`)}
        >
            <div className="clean-card-image-section">
                {badge && (
                    <div className={`property-badge ${badge === 'POPULAR' ? 'badge-yellow' : 'badge-dark'}`}>
                        {badge}
                    </div>
                )}

                {imageSync ? (
                    <img src={imageSync} alt={property.title} />
                ) : (
                    <div className="placeholder-image">No Image</div>
                )}
            </div>

            <div className="clean-card-content-section">
                <div className="clean-card-price">
                    ₹{property.price ? property.price.toLocaleString() : '0'} <span className="price-suffix">/mo</span>
                </div>

                <h3 className="clean-card-title">
                    {property.title || `${bhkSync} BHK ${property.property_type || 'Property'}`}
                </h3>

                <p className="clean-card-location">
                    {property.location || 'Bangalore, India'}
                </p>

                <div className="clean-card-specs">
                    <div className="spec-item">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d9aa41" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M4 21v-8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8"></path>
                            <path d="M2 6h20"></path><path d="M12 2v4"></path>
                        </svg>
                        <span>{bhkSync} Beds</span>
                    </div>

                    <div className="spec-item">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d9aa41" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M2 12h20"></path>
                            <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"></path>
                            <path d="M9 7v5"></path>
                            <path d="M15 7v5"></path>
                            <path d="M12 2v5"></path>
                        </svg>
                        <span>{property.bathrooms || 2} Baths</span>
                    </div>

                    <div className="spec-item">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d9aa41" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M3 21h18M5 21V7l8-4 8 4v14M17 21v-8.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V21"></path>
                        </svg>
                        <span>{sqftSync || '1,200'} sqft</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PropertyCard;
